import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Box,
  HStack,
  Text
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { SuggestionType } from 'models/ListingDataSuggestion/types';

export interface SuggestionTypeDropdownProps {
  value: SuggestionType;
  onChange: (type: SuggestionType) => void;
  size?: string;
}

const getSuggestionTypeColor = (type: SuggestionType): string => {
  switch (type) {
    case SuggestionType.ALL:
      return 'gray.500';
    case SuggestionType.ORIGINAL:
      return 'pink.500';
    case SuggestionType.SET:
      return 'teal.500';
    case SuggestionType.FAKE:
      return 'red.500';
    default:
      return 'gray.500';
  }
};

const SuggestionTypeOption = ({ type }: { type: SuggestionType }) => (
  <HStack spacing={2}>
    <Box
      width="8px"
      height="8px"
      borderRadius="full"
      backgroundColor={getSuggestionTypeColor(type)}
    />
    <Text>{type}</Text>
  </HStack>
);

export default function SuggestionTypeDropdown({
  value,
  onChange,
  size = 'md'
}: SuggestionTypeDropdownProps) {
  const handleTypeClick = (type: SuggestionType) => {
    onChange(type);
  };

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        size={size}
        textAlign="left"
        width="100%"
      >
        <SuggestionTypeOption type={value} />
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => handleTypeClick(SuggestionType.ALL)}>
          <SuggestionTypeOption type={SuggestionType.ALL} />
        </MenuItem>
        <MenuItem onClick={() => handleTypeClick(SuggestionType.ORIGINAL)}>
          <SuggestionTypeOption type={SuggestionType.ORIGINAL} />
        </MenuItem>
        <MenuItem onClick={() => handleTypeClick(SuggestionType.SET)}>
          <SuggestionTypeOption type={SuggestionType.SET} />
        </MenuItem>
        <MenuItem onClick={() => handleTypeClick(SuggestionType.FAKE)}>
          <SuggestionTypeOption type={SuggestionType.FAKE} />
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
